<template>
    <ContentWrapperControl>
        <div class="bg-white mb-4 rounded-b-lg shadow">
            <div class="p-4 text-sm">
                <div v-text="lang('lbl_0000029')" class="leading-tight"></div>
                <div v-text="lang('lbl_1000029')" class="leading-tight mt-5 font-semibold"></div>
            </div>
        </div>
        <div class="bg-white overflow-hidden mt-4 rounded-lg shadow mb-4 leading-normal">
            <div class="px-4 mt-4">
                <div class="rounded-lg border-b p-2 flex bg-grey-lighter">
                    <div class="flex items-center justify-center pr-2 border-r">
                        <img v-bind:src="require('@/assets/icons/papsi_setting_email.svg')" class="w-icon" />
                    </div>
                    <div class="flex-grow flex items-center text-sm pl-2">
                        <div v-text="$store.state.registration.email"></div>
                    </div>
                </div>
            </div>
            <div>
                <OTPControl @success="success"
                    @failed="failed"
                    @showloader="showloader"
                    @hideloader="hideloader" 
                    v-bind:type="type" 
                    v-bind:pin="$store.state.registration.otp.email.pin"
                    v-bind:email="email"
                    v-bind:name="name" />
            </div>
        </div>
    </ContentWrapperControl>
</template>

<script>
import ContentWrapperControl from './../components/controls/ContentWrapperControl.vue';
import OTPControl from './../components/controls/OTPControl.vue';
import mixin from './../mixin.js';

export default {
    mixins: [
        mixin,
    ],
    components: {
        ContentWrapperControl,
        OTPControl,
    },
    data() {
        return {
            type: 2,
            email: '',
            name: '',
        }
    },
    mounted() {
        this.$emit('checkauth', false);
        this.$emit('shownavbar', {
            title: this.lang('lbl_0000028'),
            show: true,
            back: true,
        });

        let state = this.$store.state;

        if (state.registration.hash == null || state.registration.pin == null)
        {
            this.$router.push('/signup');
        }

        this.email = state.registration.email;
        this.name = state.registration.first_name;
    },
    methods: {
        showloader() {
            this.$emit('showloader');
        },
        hideloader() {
            this.$emit('hideloader');
        },
        success(data) {
            this.$store.state.registration.otp.email.token = data.otp_token;
            this.$router.back();
        },
        failed(message) {
            this.$emit('alert', {
                theme: 'error',
                title: this.lang('lbl_0000034'),
                message: message,
            });
        },
    }
}
</script>